import React, { useState } from 'react';
import { Container, Typography, Stack, Card, Alert, Box  } from '@mui/material';
import { motion } from 'framer-motion';
import AgreementTypeDropdown from '../components/AgreementTypeDropdown';
import FileUpload from '../components/FileUpload';
import AnalysisButton from '../components/AnalysisButton';
import ResultsTable from '../components/ResultsTable';
import ModelTabs from '../components/ModelTabs';
import ModelResultsTabs from '../components/ModelResultsTabs';
import { analyzeContractText } from '../api/contractReviewApi';
import CircularProgress from '@mui/material/CircularProgress';
// import {logo} from '../TriUnity-IQ-Logo'

const mockResults = [
  {
    location: 'Section 3.1',
    clause_type: 'Termination',
    final_status: 'Non-Compliant',
    issue: 'Missing termination for cause',
    recommended_edit: 'Add "Either party may..."',
    model_disagreement: true,
    confidence: 0.91,
    clause_text: 'The agreement may be terminated with 30 days notice.',
    gpt_output: { status: 'Non-Compliant', rationale: 'Missing cause clause', edit: 'Add cause', confidence: 0.9 },
    gemini_output: { status: 'Compliant', rationale: 'Seems fine', edit: '', confidence: 0.85 },
    arbitration_output: { status: 'Non-Compliant', rationale: 'GPT correct', edit: 'Add cause', confidence: 0.91 },
  },
];

const MainPage = () => {
  const [agreementType, setAgreementType] = useState('');
  const [contractText, setContractText] = useState('');
  // const [results, setResults] = useState([]);
  const [results, setResults] = useState({
    gpt: [],
    gemini: [],
    arbitration: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <Container className="container">
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2 }}>
          <img
            src="../TriUnity-IQ-Logo.webp"
            alt="Logo"
            style={{ width: '500px', height: 'auto' }}
          />
      </Box>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Card className="card">
          <Typography variant="h4" gutterBottom color="primary" sx={{ mb: 3 }}>
            ClauseBot
          </Typography>
          <Stack spacing={3}>
            <AgreementTypeDropdown onSelect={setAgreementType} />
            <FileUpload onChange={setContractText} />
            {/* <AnalysisButton
              agreementType={agreementType}
              contractText={contractText}
              onSuccess={() => setResults(mockResults)}
            /> */}
            <AnalysisButton
              agreementType={agreementType}
              contractText={contractText}
              onSuccess={async () => {
                if (!agreementType || !contractText) return;
                setIsLoading(true); // start loading
                try {
                  const response = await analyzeContractText(contractText, agreementType);

                  if (response.status !== 1) {
                    alert('Analysis failed: ' + (response.msg || 'Unknown error'));
                    return;
                  }

                  setResults({
                    gpt: typeof response.gpt === 'object' && response.gpt !== null ? Object.values(response.gpt) : [],
                    gemini: typeof response.gemini === 'object' && response.gemini !== null ? Object.values(response.gemini) : [],
                    arbitration: typeof response.arbitration === 'object' && response.arbitration !== null ? Object.values(response.arbitration) : [], 
                  });
                } catch (err) {
                  alert('Something went wrong!');
                } finally {
                  setIsLoading(false); // stop loading
                }
              }}
            />
             {isLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                <CircularProgress size={60} thickness={5} color="primary" />
                <Typography sx={{ mt: 2 }} color="text.secondary">
                  Analyzing contract... Please wait
                </Typography>
              </Box>
            ) : (
              (results.gpt.length > 0 || results.gemini.length > 0 || results.arbitration.length > 0) ? (
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                  <ModelResultsTabs results={results} />
                </motion.div>
              ) : (
                <Alert severity="info">Upload a contract and click "Start Analysis" to see results.</Alert>
              )
            )}
          </Stack>
        </Card>
      </motion.div>
    </Container>
  );
};

export default MainPage;